import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../../../services/master/MasterService'
import UserService from '../../../../services/user/UserService'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'
import NonlalinService from '../../../../services/nonlalin/NonlalinService'
import { formatDateString, getCurrentDateFormatted, romanNum } from '../../../../utilities/Utils'
import { AsyncPaginate } from 'react-select-async-paginate'
import { FaChevronLeft, FaSave } from 'react-icons/fa'
import SweetAlert from 'react-bootstrap-sweetalert'
import { Spinner } from 'react-bootstrap'

const ViewNonLalinHeader = ({ dataHeader, cancelHeader, saveHeader }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let nonLalinService = useMemo(() => new NonlalinService(), [])

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => {
        setShowConfirmSave(true)
    }

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const [valueJenisKomoditiOpt, setValueJenisKomoditiOpt] = useState(null)
    const [valueMaksudKegiatanOpt, setValueMaksudKegiatanOpt] = useState(null)
    const [valuePeruntukanOpt, setValuePeruntukanOpt] = useState(null);
    const [valueUptOpt, setValueUptOpt] = useState(null)

    const [valueTraderOpt, setValueTraderOpt] = useState(null)
    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0);
    const [valueTraderAlamatOpt, setValueTraderAlamatOpt] = useState(null)

    const [valueNamaCp, setValueNamaCp] = useState(null)
    const [valueAlamatCp, setValueAlamatCp] = useState(null)
    const [valueTelpCp, setValueTelpCp] = useState(null)

    const [valueNamaTtd, setValueNamaTtd] = useState(null)
    const [valueJabatanTtd, setValueJabatanTtd] = useState(null)
    const [valueTempatTtd, setValueTempatTtd] = useState(null)
    const [valueTanggalTtd, setValueTanggalTtd] = useState(getCurrentDateFormatted())
    const [valueTglMasukSample, setValueTglMasukSample] = useState(getCurrentDateFormatted())
    const [valueTempatPeriksa, setValueTempatPeriksa] = useState(null)

    useEffect(() => {
        if (!dataHeader) return
        const fetchAllOptions = async () => {
            try {
                const resJenisKomoditi = await masterService.getJenisKomoditiById(dataHeader.jenisKomoditi)
                if (resJenisKomoditi) {
                    setValueJenisKomoditiOpt(resJenisKomoditi.data)

                    const resMaksud = await nonLalinService.getRefNonlalinMaksudKegiatanById(dataHeader.maksudKegiatan)
                    setValueMaksudKegiatanOpt(resMaksud.data)

                    const resUpt = await userService.getUptById(dataHeader.kodeUpt)
                    setValueUptOpt(resUpt.data)

                    const optionPeruntukan = [{ value: '1', label: 'Konsumsi' }, { value: '2', label: 'Non Konsumsi' }]
                    setValuePeruntukanOpt(optionPeruntukan.find(option => option.value === dataHeader.peruntukan))

                    const resTrader = await userService.getTraderById(dataHeader.kodeTrader)
                    setValueTraderOpt(resTrader.data)

                    const resTraderAlamat = await userService.listTraderAlamat(dataHeader.kodeTrader, dataHeader.alamatTrader, 0, 10)
                    setValueTraderAlamatOpt(resTraderAlamat.data.data)

                    setValueNamaCp(dataHeader.namaCp)
                    setValueAlamatCp(dataHeader.alamatCp)
                    setValueTelpCp(dataHeader.teleponCp)
                    setValueNamaTtd(dataHeader.namaTtd)
                    setValueJabatanTtd(dataHeader.jabatanTtd)
                    setValueTempatTtd(dataHeader.tempatTtd)
                    setValueTanggalTtd(formatDateString(dataHeader.tanggalTtd))
                    setValueTglMasukSample(formatDateString(dataHeader.tanggalMasukSample))
                    setValueTempatPeriksa(dataHeader.tempatPeriksa)
                }
            } catch (error) {

            }
        }
        fetchAllOptions()
    }, [dataHeader, masterService, userService, nonLalinService])

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                if (localStorage.getItem("kodeTrader") !== null) {
                    const resUserSession = await userService.getUserById(localStorage.getItem("userId"))
                    setValueNamaCp(resUserSession.data.nama)
                    setValueAlamatCp(resUserSession.data.alamat)
                    setValueTelpCp(resUserSession.data.telepon)
                    setValueNamaTtd(resUserSession.data.nama)
                    setValueJabatanTtd(resUserSession.data.jabatan)
                }
            } catch (error) {
                // console.log(error)
            }
        }
        fetchUserData()
    }, [userService])

    async function loadOptionJenisKomoditi(search, loadedOption, { page = 1 }) {
        const response = await masterService.listJenisKomoditi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionMaksudKegiatan(search, loadedOption, { page = 1 }) {
        const response = await nonLalinService.listRefNonlalinMaksudKegiatan(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPeruntukan(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Konsumsi'
            },
            {
                value: '2',
                label: 'Non Konsumsi'
            }
        ]
        return {
            options: options,
        }
    }

    async function loadOptionUpt(search, loadedOption, { page = 1 }) {
        const response = await userService.listUpt(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionTrader(search, loadedOption, { page = 1 }) {
        let kodeTrader = localStorage.getItem('kodeTrader')
        let response;
        if (kodeTrader !== null) {
            let trader = await userService.getTraderById(kodeTrader)
            response = await userService.listTrader(trader.data.npwp, trader.data.nama, page - 1, 10)
        } else {
            response = await userService.listTrader(search, search, page - 1, 10)
        }
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionTraderAlamat(search, loadedOption, { page = 1 }) {
        let response = await userService.listTraderAlamat(valueTraderOpt.kodeTrader, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeJenisKomoditi = e => {
        setValueJenisKomoditiOpt(e)
    }

    const onChangeMaksudKegiatan = e => {
        setValueMaksudKegiatanOpt(e)
    }

    const onChangePeruntukan = e => {
        setValuePeruntukanOpt(e)
    }

    const onChangeUpt = e => {
        setValueUptOpt(e)
    }

    const onChangeTrader = e => {
        setKeyForSecondSelect(prevKey => prevKey + 1)
        setValueTraderOpt(e)
    }

    const onChangeTraderAlamat = e => {
        setValueTraderAlamatOpt(e)
    }

    const onChangeNamaTtd = e => {
        setValueNamaTtd(e.target.value)
    }

    const onChangeJabatanTtd = e => {
        setValueJabatanTtd(e.target.value)
    }

    const onChangeTempatTtd = e => {
        setValueTempatTtd(e.target.value)
    }

    const onChangeTanggalTtd = e => {
        setValueTanggalTtd(e.target.value)
    }

    const onChangeTempatPeriksa = e => {
        setValueTempatPeriksa(e.target.value)
    }

    const onChangeTanggalMasukSample = e => {
        setValueTglMasukSample(e.target.value)
    }

    const [kelengkapan, setKelengkapan] = useState({})

    const checkKelengkapan = () => {
        const checkKelengkapan = {}
        if (!valueJenisKomoditiOpt) checkKelengkapan.jenisKomoditi = 'Jenis Komoditi Wajib Diisi'
        if (!valueMaksudKegiatanOpt) checkKelengkapan.maksudKegiatan = 'Maksud Kegiatan Wajib Diisi'
        if (!valuePeruntukanOpt) checkKelengkapan.peruntukan = 'Peruntukan Wajib Diisi'
        if (!valueUptOpt) checkKelengkapan.upt = 'UPT Wajib Diisi'
        if (!valueTraderOpt) checkKelengkapan.pengirim = 'Perusahaan Wajib Diisi'
        if (!valueTraderAlamatOpt) checkKelengkapan.alamat = 'Alamat Perusahaan Wajib Diisi'
        if (!valueTglMasukSample) checkKelengkapan.tglMasukSample = 'Tanggal Masuk Sample Wajib Diisi'
        if (!valueTempatTtd) checkKelengkapan.tempatTtd = 'Tempat Penandatangan Wajib Diisi'
        if (!valueTempatPeriksa) checkKelengkapan.tempatPeriksa = 'Tempat Pemeriksaan Wajib Diisi'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const handleClickSimpan = async () => {
        localStorage.removeItem('dataHeaderStorage')
        if (checkKelengkapan()) {

            let nomorAju
            let tanggalAju
            if (dataHeader === undefined || dataHeader === null || Object.keys(dataHeader).length === 0) {
                const respNomor = await pbumkuService.ambilNomorService('NLL_AJU', valueUptOpt.kdUnit, currentYear, localStorage.getItem('username'))
                nomorAju = respNomor.data.uraianPusat + respNomor.data.kodePusat + romanNum(currentMonth) + currentYear + respNomor.data.nomorUrut
                tanggalAju = new Date()
            } else {
                nomorAju = dataHeader.nomorAju
                tanggalAju = dataHeader.tanggalAju
            }

            let dataheader = {
                ...dataHeader,
                nomorAju: nomorAju,
                tanggalAju: tanggalAju,
                status: (dataHeader === undefined || dataHeader === null || Object.keys(dataHeader).length === 0) ? '000' : dataHeader.status,
                kdKegiatan: 'N',
                jenisKomoditi: valueJenisKomoditiOpt.id,
                maksudKegiatan: valueMaksudKegiatanOpt.id,
                peruntukan: valuePeruntukanOpt.value,
                kodeUpt: valueUptOpt.kdUnit,
                kodeTrader: valueTraderOpt.kodeTrader,
                npwpTrader: valueTraderOpt.npwp,
                namaTrader: valueTraderOpt.nama,
                alamatTrader: (valueTraderAlamatOpt.alamat === null || valueTraderAlamatOpt.alamat === undefined) ? valueTraderOpt.alamat : valueTraderAlamatOpt.alamat,
                kodeposTrader: (valueTraderAlamatOpt.kodepos === null || valueTraderAlamatOpt.kodepos === undefined) ? valueTraderOpt.kodepos : valueTraderAlamatOpt.kodepos,
                namaCp: valueNamaCp,
                alamatCp: valueAlamatCp,
                teleponCp: valueTelpCp,
                namaTtd: valueNamaTtd,
                jabatanTtd: valueJabatanTtd,
                tempatTtd: valueTempatTtd,
                tanggalTtd: valueTanggalTtd,
                dateCreated: new Date(),
                tempatPeriksa: valueTempatPeriksa,
                tanggalMasukSample: valueTglMasukSample,
                userCreated: localStorage.getItem('username').substring(0, 5)
            }

            try {
                setLoadingSave(true)
                const response = await nonLalinService.saveNonlalinHeader(JSON.stringify(dataheader))
                if (response.data.kode === '200') {
                    let jsonStatus = {
                        nomorAju: nomorAju,
                        kodeStatus: '000',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem("username"),
                        createdAt: new Date()
                    }
                    await nonLalinService.saveNonlalinStatus(jsonStatus)

                    setShowSaveSucces(true)
                    setShowConfirmSave(false)
                    localStorage.setItem('dataHeaderStorage', JSON.stringify(dataheader))
                    localStorage.setItem('nomorAjuStorage', nomorAju)
                }
                setLoadingSave(false)
            } catch (error) {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setLoadingSave(false)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setLoadingSave(false)
        setShowSaveSucces(false)
        saveHeader('detil')
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row mb-3">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Jenis Komoditi<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionJenisKomoditi}
                                        value={valueJenisKomoditiOpt}
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) => option.jenisKomoditi}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeJenisKomoditi}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.jenisKomoditi && <div className="text-danger">{kelengkapan.jenisKomoditi}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Maksud Kegiatan<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionMaksudKegiatan}
                                        value={valueMaksudKegiatanOpt}
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) => option.urMaksudKegiatan}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeMaksudKegiatan}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.maksudKegiatan && <div className="text-danger">{kelengkapan.maksudKegiatan}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Peruntukan<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionPeruntukan}
                                        value={valuePeruntukanOpt}
                                        getOptionValue={(option) => option.value}
                                        getOptionLabel={(option) => option.label}
                                        additional={{
                                            page: 0,
                                        }}
                                        onChange={onChangePeruntukan}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.peruntukan && <div className="text-danger">{kelengkapan.peruntukan}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">UPT<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionUpt}
                                        value={valueUptOpt}
                                        getOptionValue={(option) => option.kdUnit}
                                        getOptionLabel={(option) => option.nmUnit}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeUpt}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.upt && <div className="text-danger">{kelengkapan.upt}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Perusahaan</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">NPWP</label>
                                    <input type="text" className="form-control-sm" name="npwp_eksportir" placeholder="NPWP Eksportir" value={valueTraderOpt !== null ? valueTraderOpt.npwp : ''} readOnly />
                                </div>
                            </div>
                            <div className="col-8">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        loadOptions={loadOptionTrader}
                                        value={valueTraderOpt}
                                        getOptionValue={(option) => option.kodeTrader}
                                        getOptionLabel={(option) => option.kodeTrader + '-' + option.nama}
                                        additional={{
                                            page: 1,
                                        }}
                                        onChange={onChangeTrader}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.pengirim && <div className="text-danger">{kelengkapan.pengirim}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Pilih Alamat<span className="text-danger"> *</span></label>
                                    <AsyncPaginate
                                        key={keyForSecondSelect}
                                        loadOptions={loadOptionTraderAlamat}
                                        value={valueTraderAlamatOpt}
                                        getOptionLabel={(option) => option.alamat + ' - Kode Pos : ' + option.kodepos}
                                        getOptionValue={(option) => option.alamat}
                                        additional={{
                                            page: 1
                                        }}
                                        onChange={onChangeTraderAlamat}
                                        isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                    />
                                    {kelengkapan.alamat && <div className="text-danger">{kelengkapan.alamat}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">

                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Penanggungjawab</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama</label>
                                    <input type="text" className="form-control-sm" name="nama_pj" placeholder="Nama Penanggungjawab" value={valueNamaCp} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Alamat</label>
                                    <textarea rows={3} className="form-control" name="alamat_pj" value={valueAlamatCp} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nomor Telepon</label>
                                    <input type="text" className="form-control-sm" name="telp_pj" placeholder="Nomor Telepon" value={valueTelpCp} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Penandatangan Dokumen Permohonan</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Nama TTD</label>
                                    <input type="text" className="form-control-sm" name="nama_ttd" placeholder="Nama Penandatangan" value={valueNamaTtd} onChange={onChangeNamaTtd} />
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Jabatan TTD</label>
                                    <input type="text" className="form-control-sm" name="jabatan_ttd" placeholder="Jabatan Penandatangan" value={valueJabatanTtd} onChange={onChangeJabatanTtd} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Tempat TTD<span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control-sm" name="tempat_ttd" placeholder="Tempat" value={valueTempatTtd} onChange={onChangeTempatTtd} />
                                    {kelengkapan.tempatTtd && <div className="text-danger">{kelengkapan.tempatTtd}</div>}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Tanggal TTD</label>
                                    <input type="date" className="form-control-sm" name="tanggal_ttd" value={valueTanggalTtd} onChange={onChangeTanggalTtd} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pemeriksaan</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label className="col-form-label-sm">Tempat Pemeriksaan<span className='text-danger'> *</span></label>
                                    <input type="text" className="form-control-sm" name="tempat_periksa" placeholder="Tempat Pemeriksaan" value={valueTempatPeriksa} onChange={onChangeTempatPeriksa} />
                                    {kelengkapan.tempatPeriksa && <div className='text-danger'>{kelengkapan.tempatPeriksa}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <label className="col-sm-6 col-form-label-sm">Tanggal Masuk Sample<span className="text-danger"> *</span></label>
                            <input type="date" className="col-sm-12 form-control-sm" name="tgl_masuk_sample" onChange={onChangeTanggalMasukSample} value={valueTglMasukSample} readOnly={localStorage.getItem('isEditStorage') === '0' ? true : false} />
                            {kelengkapan.tglMasukSample && <div className="text-danger">{kelengkapan.tglMasukSample}</div>}
                        </div>

                    </div>
                </div>
                {
                    localStorage.getItem('isEditStorage') === '1' ? <>
                        <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={handleShowConfirmSave} ><FaSave /> Simpan & Lanjutkan</button>
                        <button type="button" name="back" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Kembali" onClick={() => cancelHeader()} ><FaChevronLeft /> Batal</button>
                    </> : ''
                }
            </div>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Entitas?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Entitas Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Entitas Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ViewNonLalinHeader